{
    "roadmap": {
        "common": {
            "openAll": "Alle öffnen",
            "closeAll": "Alle schließen",
            "openorCloseTitle": "Alle Akkordeons öffnen/schließen"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Was ist NextGen IT: IT-Automatisierung für Endbenutzer und schnellere Problemlösung.",
            "acc1Title": "In Produktion",
            "prodItem1": "KB-Artikel-Integration: 300+ KB-Artikel ermöglichen IT-Selbstlösung",
            "prodItem2": "Selbstheilungslösung: Mehr als 18 Remote-Skripte stehen zur Problemlösung zur Verfügung.",
            "prodItem3": "Vorfallserstellung: Sorgt für eine genaue und schnellere Lösung durch automatisierte Vorfallprotokollierung.",
            "prodItem4": "Chat mit Live-Agent (menschlicher Agent): MyHelp ermöglicht Benutzern, mit einem menschlichen Agenten vom AI-Assistenten zu chatten",
            "acc2Title": "In Entwicklung",
            "devItem1": "Rückruf planen (Feb - 2026): Planen Sie einen IT-Support-Rückruf zu einer Zeit, die Ihnen passt",
            "devItem2": "Intelligente Weiterleitung (Feb - 2026): Leitet Tickets an das richtige Lösungsteam für schnellere Unterstützung weiter",
            "acc3Title": "Backlog",
            "backItem1": "PKI-Fehlerbehebungsagent: MyHelp-Integration mit dem PKI-Fehlerbehebungsagent zur Lösung von zertifikatsbezogenen Problemen",
            "backItem2": "Termine im Walk-in-Center direkt über MyHelp planen"
        },
        "corporate": {
            "title": "Corporate",
            "desc": "Das Corporate ist verantwortlich für die Verwaltung von Unternehmensanwendungen, HR-Plattformen, die Arbeitskräfte und Geschäftsprozesse unterstützen.",
            "acc1Title": "In Produktion",
            "prodItem1": "BU-basierte Apps: 90+ Apps mit BU-basierter Personalisierung",
            "prodItem2": "Benutzerdefiniertes App-Pinning: Benutzer können ihr MyHelp-Dashboard durch das Pinnen benutzerdefinierter Apps personalisieren",
            "prodItem3": "Arbeitsplatzanfragen: 100+ Arbeitsplatzanfragen (Büro, Parken, Gebäude)",
            "prodItem4": "Besprechungsraum-Buchung mit AI-Assistent: Schnelle, vereinfachte Besprechungsraum-Buchung mit Gingco-Integration",
            "prodItem5": "HR-Anfragen: MyHelp beantwortet die Top 50 HR-Anfragen",
            "prodItem6": "Personensuche: Benutzer können nach ihren E.ON-Kollegen über MyHelp suchen",
            "acc2Title": "In Entwicklung",
            "devItem1": "Anwendungs-Onboarding basierend auf der Einführung der Geschäftseinheit.",
            "devItem2": "Besprechungsraum AI-Assistent",
            "acc3Title": "Im Backlog",
            "backItem1": "Apps vom AI-Assistenten und benutzerdefinierte Tabs hinzufügen: Apps sofort über die vorgeschlagenen Optionen des MyHelp-Assistenten hinzufügen"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Diese Integration hilft Ihnen, relevante Schulungen und Kurse zu finden.",
            "acc1Title": "In Produktion",
            "prodItem1": "Schulungen & Kurse suchen: Finden Sie relevante Schulungen und Kurse mit MyHelp",
            "acc2Title": "In Entwicklung",
            "acc3Title": "Im Backlog",
            "backItem1": "Personalisierte Lernempfehlungen: Personalisierte Schulungsempfehlungen basierend auf der Berechtigung der Geschäftseinheit."
        },
        "myItOrder": {
            "title": "MyIT-Bestellung",
            "desc": "Diese Integration hilft Ihnen, relevante IT-Bestellartikel und Kataloge zu finden.",
            "acc1Title": "In Produktion",
            "prodItem1": "Schnelle IT-Bestellkatalogsuche: Schnelle Suche und Bestellung Ihrer IT über MyHelp",
            "prodItem2": "Softwarezugriff aktivieren & widerrufen: Softwarezugriff über MyHelp aktivieren oder widerrufen.",
            "acc2Title": "In Entwicklung",
            "devItem1": "Kostenübersicht der IT-Assets: MyHelp zeigt eine Kostenübersicht Ihrer IT-Assets an",
            "acc3Title": "Im Backlog",
            "backItem1": "Zentrale Genehmigung der bestellten Artikel"
        },
        "compass": {
            "title": "Kompass",
            "desc": "Diese Integration hilft Ihnen, Gemeinschafts-, Nachrichteninformationen und Ankündigungen zu finden, die im Intranet geteilt werden.",
            "acc1Title": "In Produktion",
            "prodItem1": "Wird bis zum 28. Februar 2026 veröffentlicht",
            "acc2Title": "In Entwicklung",
            "devItem1": "Kompass-Suche (Feb – 2026): E.ON-Benutzer können ihre Gemeinschaftsdaten in der MyHelp E.ON-Suche durchsuchen",
            "devItem2": "MyHelp-Kompass AI-Assistent (in Arbeit) (Feb – 2026): Ermöglicht E.ON-Benutzern den Zugriff auf Gemeinschaftsdaten über den MyHelp AI-Assistenten",
            "acc3Title": "Im Backlog"
        },
        "chatProjectData": {
            "title": "Chat mit Ihren Projektdaten",
            "desc": "Diese Integration ermöglicht es Ihnen, Ihre Projektdaten aus Confluence, SharePoint usw. zu onboarden.",
            "acc1Title": "In Produktion",
            "prodItem1": "Confluence One Billing und DSODP-Projekte sind onboarded",
            "prodItem2": "SharePoint-Seiten – DSODP-Projektseite ist onboarded",
            "acc2Title": "In Entwicklung",
            "devItem1": "Die Integration der Nautilus-Projektdaten ist derzeit in Arbeit.",
            "acc3Title": "Im Backlog"
        },
        "personalization": {
            "title": "Personalisierung",
            "acc1Title": "In Produktion",
            "prodItem1": "Mehrsprachig: unterstützt 4 Sprachen (Englisch, Deutsch, Svenska, Română)",
            "prodItem2": "Multi-Theme: ermöglicht es jeder Geschäftseinheit oder Region, ihr eigenes Branding zu verwenden, um Vertrautheit und Akzeptanz zu verbessern.",
            "prodItem3": "5 zusätzliche neue Sprachen im Beta-Profil (Čeština, Italiano, Magyar, Nederlands und Polski)",
            "acc2Title": "In Entwicklung",
            "devItem1": "Datenquellen-spezifisch: (15. Feb – 2026): bietet gezieltere und kontextbewusste Antworten, indem Informationen aus den ausgewählten Datenquellen des Benutzers abgerufen werden.",
            "acc3Title": "Im Backlog"
        },
        "technicalEnablement": {
            "title": "Technische Befähigung",
            "acc1Title": "In Produktion",
            "prodItem1": "Sicherheit & Beobachtbarkeit gewährleisten Datenschutz, Compliance und Leistung auf Unternehmensniveau und ermöglichen einen sicheren, zuverlässigen und reibungslosen Betrieb",
            "prodItem2": "KPI- & Adoptions-Dashboards (Power BI)<br /> Bietet klare Sichtbarkeit in Nutzung, Wertrealisierung und Geschäftsauswirkungen durch KPI-Dashboards",
            "acc2Title": "In Entwicklung",
            "devItem1": "Multiagenten-Workflow bis zum 15. März 2026: Ermöglicht absichtsgetriebene Gespräche, die nicht nur die Antwortrelevanz verbessern, sondern auch End-to-End für Benutzer ausführen.",
            "acc3Title": "Im Backlog",
            "backItem1": "MCP-Framework (Backlog): <br /> Bietet eine Grundlage zur Orchestrierung und Koordination von AI-Agenten über E.ON hinweg, um skalierbare und kollaborative Unternehmens-AI-Fähigkeiten zu ermöglichen."
        }
    }
}